module.exports = __webpack_public_path__ + "img/help-set-up-the-plant@2x.156a750c.webp";